import style from '../styles/expenses.header.module.css'

const ExpensesHeader = ({module_v}) => {
    return (
        <div className={style.container}>
            <div className={style.header__text}>
                Управление расходами компании
            </div>
            <div className={style.description__text}>
                Модуль: {module_v}
            </div>

        </div>
    )
}

export default ExpensesHeader;